import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { convertSearchUrl, getDateMoment, getFilterFromUrl } from 'utils/tools';
import FilterCustom from 'components/common/FilterCustom';
import { formatFromToTimeFilterSubmit } from 'utils/dataUtils';
import { DEFAULT_CURRENT_PAGE } from 'configs/localData/constant';
import { omit } from 'lodash-es';
import ContactFilterForm from './FilterForm';

interface Props {
  refresh?: () => void;
}

const ContactFilterCustom = ({ refresh }: Props) => {
  const { push } = useHistory();
  const { search } = useLocation();
  const { filter: query } = getFilterFromUrl(search);

  const onSubmitFilter = (values) => {
    refresh();
    const createdAt = formatFromToTimeFilterSubmit(values?.createdAt);
    const lastActiveAt = formatFromToTimeFilterSubmit(values?.lastActiveAt);
    const restFilter = {
      ...values,
      createdAt,
      lastActiveAt,
      page: DEFAULT_CURRENT_PAGE,
    };

    push({
      search: `?${convertSearchUrl({
        ...omit(restFilter, ['page']),
      })}`,
    });
  };

  const onClearFilter = () => {
    push({ search: `?` });
  };

  return (
    <FilterCustom
      initialValues={{
        ...query,
        lastActiveAt: [
          getDateMoment(query?.lastActiveAt?.from),
          getDateMoment(query?.lastActiveAt?.to),
        ],
        createdAt: [
          getDateMoment(query?.createdAt?.from),
          getDateMoment(query?.createdAt?.to),
        ],
      }}
      onSubmitFilter={onSubmitFilter}
      onClearFilter={onClearFilter}
    >
      <ContactFilterForm />
    </FilterCustom>
  );
};

export default ContactFilterCustom;
